<template>
    <div class="custom-form-group" :class="[formGroupClass, {'is-invalid': getError(name)}]">
        <label class="form-label" :for="uniqid" v-if="!floatLabel && label">{{ label }}<span v-if="required">*</span></label>
        <div :class="{'input-group has-validation': addon, 'form-floating': floatLabel}">
            <input
                :type="fieldType"
                :id="uniqid"
                :name="name"
                :placeholder="(floatLabel ? label : placeholder)"
                class="form-control"
                :class="[inputClass, {'is-invalid': getError(name)}]"
                :value="value"
                :disabled="disabled"
                @keyup="updateValue($event.target.value)"
                @change="(event) => {
                    updateValue(event.target.value)
                    formatPhoneNumber(event.target.value)
                }"
                :aria-describedby="uniqid+'-addon '+uniqid+'-feedback'"
            />
            <div @click="toggleVisiblePassword()" class="password-eye" v-if="type == 'password'"><img src="/images/card/password-eye-hidden.svg" v-if="fieldType == 'password'"><img src="/images/card/password-eye.svg" v-if="fieldType == 'text'"></div>
            <label :for="uniqid" v-if="floatLabel && label">{{ label }}<span v-if="required">*</span></label>
            <span class="input-group-text" :id="uniqid+'-addon'" v-if="addon"> {{ addon }}</span>
            <div class="custom-info" v-if="customInfo"> {{ customInfo }}</div>
            <div class="invalid-feedback" :id="uniqid+'-feedback'">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import uniqid from 'uniqid'

export default {

    props: {
        value: {
            required: true
        },
        type: {
            default: 'text'
        },
        disabled: {
            default: false
        },
        name: {
            required: true
        },
        label: {
            default: false
        },
        placeholder: {
            default: ''
        },
        customInfo: {
            default: false
        },
        addon: {
            default: false
        },
        formGroupClass: {
            default: null
        },
        inputClass: {
            default: null
        },
        customErrorMessage: {
            default: null
        },
        floatLabel: {
            default: false
        },
        required: {
            default: false
        }
    },

    inject: [
        'getError',
        'clearError'
    ],

    data () {
        return {
            uniqid: uniqid(),
            fieldType: this.type
        }
    },

    computed: {
        errorMessage () {
            if (this.getError(this.name) && Array.isArray(this.getError(this.name))) {
                if (this.customErrorMessage) {
                    return this.customErrorMessage
                } else {
                    return this.getError(this.name)[0]
                }
            }
            return ''
        }
    },

    methods: {
        updateValue (value) {
            this.$emit('input', value)
            this.clearError(this.name)
        },

        formatPhoneNumber (input) {
            if (this.type !== 'tel') {
                return
            }

            let phoneNumber = input

            phoneNumber = phoneNumber.replace(/\.|\-|\ /g, '')

            const prefix = phoneNumber.substring(0, 2)
            if (prefix == '00') {
                phoneNumber = '+' + phoneNumber.substring(2)
            }

            const prefix2 = phoneNumber.substring(0, 1)
            if (prefix2 == '0') {
                phoneNumber = '+46' + phoneNumber.substring(1)
            }

            this.updateValue(phoneNumber)
        },

        toggleVisiblePassword () {

            if(this.fieldType == 'password')
            {
                this.fieldType = 'text'
            }else{
                this.fieldType = 'password'
            }

        }
    }

}
</script>
